module.exports = __webpack_public_path__ + "img/other01.8997f1ec.png";